import { defineStore } from 'pinia'
import { ref } from 'vue'
import { removeLocalCache } from '@/utils/cache'

export const usePromoterInfoStore = defineStore(
  'usePromoterInfo',
  () => {
    const promoterInfo = ref()
    const setPromoterInfo = (value) => {
      promoterInfo.value = value
    }

    const getPromoterInfo = () => {
      return promoterInfo.value
    }

    const removeAll = () => {
      promoterInfo.value = null
      removeLocalCache('promoterInfo')
    }

    return { promoterInfo, setPromoterInfo, getPromoterInfo, removeAll }
  },
  {
    // 添加持久化配置
    persist: true,
  },
)
